import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../components/UserContext';
import { API_URL } from '../config';

export const usePageViewTracking = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);

  useEffect(() => {
    // Generate or retrieve session ID
    let sessionId = sessionStorage.getItem('analyticsSessionId');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(7)}`;
      sessionStorage.setItem('analyticsSessionId', sessionId);
    }

    // Track page view
    const trackPageView = async () => {
      try {
        await fetch(`${API_URL}/analytics/pageview`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            path: location.pathname + location.search,
            referrer: document.referrer,
            sessionId: sessionId,
            userId: user?._id || null
          })
        });
      } catch (error) {
        // Silent fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageView();
  }, [location, user]);
};
